// extracted by mini-css-extract-plugin
module.exports = {"searchBtn":"_2YgdQwT62G0E","dropMenu":"_3MU4k1-_p-23","group":"_1RPTNcEe7GDP"};